<template>
  <div class="checkbox-group-edit-modal" v-if="showModal">
    <div class="modalHeader" style="border-radius: 9px 9px 0px 0px !important;">
      <span class="title">Edit Section</span>
      <span @click="closeModal" class="btn-close float-right"><i class="fas fa-times"></i></span>
    </div>

    <div class="modalBody">
      <div class="form-group">
        <label class="font14"><b>Label:</b></label>
        <input type="text" class="form-control form-control-sm" v-model="editLabel">
      </div>
      <div class="form-group">
        <label class="font14"><b>Help Text:</b></label>
        <textarea class="form-control form-control-sm" v-model="editHelp" />
      </div>
      <div class="form-group">
        <label class="font14"><b>Prefix:</b></label>
        <input type="text" class="form-control form-control-sm" v-model="prefix">
      </div>

      <div class="button-box mr-0 float-right">
        <button class="btn btn-success" @click="saveEdit">Save</button>
        <button class="btn btn-secondary" @click="closeModal">Close</button>
      </div>

      <table class="table table-sm table-bordered table-striped">
        <thead>
          <tr>
            <th>Field ID</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(field, index) in fieldList" :key="index">
            <td>{{ field }}</td>
            <td>
              <button class="btn btn-sm btn-light" @click="editFormField(index)">Edit Form Field</button>
              <button class="btn btn-sm btn-danger" @click="deleteField(index)">Remove</button>
              <i class="fas fa-angle-double-up" @click="move(index, true)"></i>
              <i class="fas fa-angle-double-down" @click="move(index, false)"></i>
            </td>
          </tr>
        </tbody>
      </table>

      <div>
        <hr>

        <questionnaire-tags
          :fieldData="fieldData"
        />
      </div>

      <hr>

      <div class="row modal-section" id="AbGroupWatchersSection">
        <div class="col-sm-12">
          <ab-group-watchers
            :isGroup="false"
            :fieldData="fieldData"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QuestionnaireTags from '@/components/questionnaires/QuestionnaireTags'
import AbGroupWatchers from '@/components/questionnaires/ABGroupWatchers'

export default {
  name: 'section-edit-modal',

  mounted () {
    let that = this
    this.$bus.on('sectionEditModal', function (fieldId) {
      that.fieldId = fieldId
      let storeSection = that.$store.state.questionnaires[that.$store.state.currentTemplateName].data[fieldId]

      if (storeSection === undefined) {
        storeSection = fieldId
        that.fieldData = fieldId
      } else that.fieldData = that.$store.state.questionnaires[that.$store.state.currentTemplateName].data[that.fieldId]

      that.editName = storeSection.fieldName
      that.editLabel = storeSection.originalValue
      that.editHelp = storeSection.desc
      that.fieldList = storeSection.fieldsAdded
      that.prefix = storeSection.prefix
      that.showModal = true
    })

    document.addEventListener('keyup', this.keyCheck)
  },

  beforeDestroy () {
    document.removeEventListener('keyup', this.keyCheck, false)

    this.$bus.$off('sectionEditModal')
  },

  data () {
    return {
      fieldId: '',
      showModal: false,
      editName: '',
      editLabel: '',
      editHelp: '',
      fieldList: {},
      fieldData: {},
      prefix: ''
    }
  },

  components: {
    QuestionnaireTags,
    AbGroupWatchers
  },

  methods: {
    deleteField (index) {
      let list = []
      list = this.fieldList
      Object.keys(list).forEach(id => {
        if (id === index) delete list[id]
      })

      this.fieldList = Object.assign({}, this.fieldList, list)
      this.$store.commit('setFieldsAddedToSection', {
        dataFields: this.fieldList,
        sectionIndex: this.fieldId
      })
      // this.$bus.emit('updateQuestionnaire')
      this.$bus.emit('reloadQuestionnaire')
      if (Object.keys(this.fieldList).length === 0) this.showModal = false
    },

    move (moveIndex, up) {
      let tmpContainer = {}
      let targetIndex = -1
      let keys = []
      keys = Object.keys(this.fieldList)

      for (let index = 0; index < keys.length; index++) {
        tmpContainer[index] = keys[index]
        if (moveIndex === keys[index]) targetIndex = index
      }

      if (targetIndex === -1) return
      if (up && targetIndex - 1 < 0) return
      if (!up && targetIndex + 1 > keys.length - 1) return
      let newTarget = up ? targetIndex - 1 : targetIndex + 1

      keys.splice((newTarget < 0 ? keys.length + newTarget : newTarget), 0, keys.splice(targetIndex, 1)[0])

      let newData = {}
      for (let index = 0; index < keys.length; index++) {
        const element = keys[index]
        newData[element + '-' + Math.random().toString(36).split('.')[1]] = this.fieldList[element]
      }

      this.fieldList = newData
      this.$store.commit('setFieldsAddedToSection', {
        dataFields: this.fieldList,
        sectionIndex: this.fieldId
      })
      // this.$bus.emit('updateQuestionnaire')
      this.$bus.emit('reloadQuestionnaire')
    },

    keyCheck (evt) {
      if (evt.keyCode === 27) this.closeModal()
    },

    closeModal () {
      this.showModal = false
    },

    saveEdit () {
      this.$store.commit('editSection', {
        index: this.fieldId,
        name: this.editName,
        label: this.editLabel,
        help: this.editHelp,
        prefix: this.prefix
      })

      // this.$bus.emit('updateQuestionnaire')
      this.$bus.emit('reloadQuestionnaire')
      this.showModal = false
    },

    editFormField (index) {
      this.$bus.emit('openFieldMenu', {
        id: index
      })
      this.showModal = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .checkbox-group-edit-modal {
    position: fixed;
    top: 10%;
    left: 50%;
    margin-left: -45%;
    width: 90%;
    max-width: 1700px;
    min-height: 600px;
    max-height: 90%;
    border: 1px solid black;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #FFF;
    z-index: 100;

    .modalHeader {
      background-color: #2d5f8b;
      color: #FFF;
      font-size: 18px;
      padding: 5px 10px 5px 10px;
      height: 37px;
    }

    .btn-close {
      cursor: pointer;
      color: #FFF;
    }

    .modalBody {
      position: absolute;
      padding: 10px;
      width: 100%;
      height: calc(100% - 37px);
      overflow-y: auto;
    }
  }

  .button-box {
    float: right;
    margin-right: 30px;
    margin-bottom: 15px;
    .btn {
      margin-left: 10px;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/questionnaires/SectionEditModal.vue